import styled from 'styled-components';
const Container = styled.div `
  padding: 20px 0;
`;
const ImageWrapper = styled.div `
  position: relative;
  margin: 0 0 10px;
  height: 230px;
`;
const Image = styled.img `
  height: 100%;
  object-fit: contain;
  width: 100%;
`;
const Title = styled.h3 `
  color: #000;
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  margin: 0 0 10px;
`;
const Content = styled.p `
  color: #000;
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  margin: 0;
`;
export default {
    Container,
    Content,
    Image,
    ImageWrapper,
    Title,
};
